import $ from 'jquery'
import axios from 'axios'
import Routing from 'fos-router';
import routes  from '../../../../CustomerBundle/public/js/data/fos_js_routes';
window.jQuery = window.$ = $;

const productImageZoom = ( isCursor ) => {

	const _zoomScreenWidth = 992;
    const _imageZoomSize = 450;
    const _mobileWidth = 767;
    const _zoomedSize = 1300;

    const selZoomImg = '.product-zoom';
    const clLens = 'lens';

    const resizeZoomImage = async elLink => {
        Routing.setRoutingData( routes );

        const url = Routing.generate('images_resize', {
            id: elLink.parent().data('imageid'),
            width: _zoomedSize,
            height: _zoomedSize,
            pad: 0
        });

        try {
            const response = await axios.post( url );
            if( typeof response.data.url != 'undefined' ) {
                elLink.attr('href', response.data.url );
                initImageZoom( elLink.find('img'), response.data.url );
            }
        } catch (error) {
            throw error;
        } 

        return '';
    };

    const initImageZoom = ( elImg, fullUrl ) => {
      if (fullUrl) {
        elImg.trigger('zoom.destroy');        
        elImg.zoom({
            url: fullUrl,
            target: '.zoomed-image',
            tint: '#333',
            duration: 750,
            magnify: 1.5
        });
      }
    }

    const init = () => {     
        if ($(window).width() >= _zoomScreenWidth || isCursor) {

          $(`${selZoomImg} img`).each(function () {
            const $img = $(this);
            const fullUrl = $img.attr('href') || $img.data('zoom-image') || $img.closest('a').attr('href');

            initImageZoom( $img, fullUrl );
          });

          $( selZoomImg ).on( 'mouseenter', function() {
              let lens = $( `.${clLens}`, this);
              if( ! lens.length ) {
                  lens = $('<div>').addClass( clLens ).appendTo(this);
              }
              lens.fadeIn(200);
          }).on('mousemove', function(e) {
            const selLens = `.${clLens}`;
            const lens = $( selLens, this);
            const rect = this.getBoundingClientRect();
            let x = 27 + e.clientX - rect.left - lens.width() / 2;
            let y = 25 + e.clientY - rect.top - lens.height() / 2;

            x = Math.max( -27, Math.min(x, this.offsetWidth ) );
            y = Math.max( -25, Math.min(y, this.offsetHeight ) );

            lens.css( { left: x + 'px', top: y + 'px' } );
          }).on( 'mouseleave', function() { $( `.${clLens}`, this).fadeOut(200); });
        }

        $( selZoomImg + '[href=""]' ).each( function() {
            resizeZoomImage( $(this) );
        });
    };

  init();
};

export default productImageZoom;